// shoelace components - IMPORTANT: need to remove the "dist" from the path
import "@shoelace-style/shoelace/dist/components/select/select.js";
import "@shoelace-style/shoelace/dist/components/option/option.js";
import "@shoelace-style/shoelace/dist/components/details/details.js";
import "@shoelace-style/shoelace/dist/components/tab-group/tab-group.js";
import "@shoelace-style/shoelace/dist/components/rating/rating.js";
import "@shoelace-style/shoelace/dist/components/tab/tab.js";
import "@shoelace-style/shoelace/dist/components/tab-panel/tab-panel.js";
import "@shoelace-style/shoelace/dist/components/spinner/spinner.js";
import '@shoelace-style/shoelace/dist/components/tag/tag.js';

// data
import { makeModelData, yearModelData, engineData } from "./utils/ymmData";

// import homepage slider - (probably should have pages of JS but for now its ok)
import { homePageSlider } from "./components/homepageSlider";

// import collection filtering
import { handleColectionFilters } from "./utils/filters";

// vendor libs
import Alpine from "alpinejs";

document.addEventListener("DOMContentLoaded", () => {
  let needFiltering = document.getElementById("customCollectionFilter");
    const currentUrl = window.location.href;
  if (needFiltering && typeof needFiltering != "undefined") {
    document.querySelectorAll(".filterClickListener").forEach((element) => {
      element.addEventListener("click", () => {
        if (!element.value) {
          // null check
          console.log("ERROR: FILTERING ERROR NO VALUE SELECTED");
        } else {
          handleColectionFilters(currentUrl, element.value);
        }
      });
    });
  }

  let needsActiveFilterDisplay = document.querySelectorAll("#bmpCustomActiveFilter");
  needsActiveFilterDisplay = needsActiveFilterDisplay.length > 0 ? true : false;

  if (needsActiveFilterDisplay && typeof needsActiveFilterDisplay !== "undefined") {

    const div = document.querySelectorAll('.tags-removable');
    div.forEach((div) => {
    if (div) {
        div.addEventListener('sl-remove', event => {

            if (!event.target.dataset.tag) return;

            // Enhanced function to filter out the argument from the current path array, handling appended segments
            const filterOutArgument = (arr, argumentToRemove) => {
                return arr.map(item => {
                    // Split the item by '+' and filter out the argumentToRemove, then join back with '+'
                    const parts = item.split('+').filter(part => part !== argumentToRemove);
                    return parts.join('+');
                }).filter(item => item !== '' && item !== argumentToRemove); // Ensure we remove the item if it matches or is empty after removal
            };

            const currentPathArray = window.location.pathname.split('/').filter(Boolean);
            const argumentToRemove = event.target.dataset.tag;

            const newPathArray = filterOutArgument(currentPathArray, argumentToRemove);
            const newPath = `${window.location.origin}/${newPathArray.join('/')}`;


            // Update the browser's URL bar and navigate to the new URL
            window.location.href = newPath;

            // Optional: Visual feedback for tag removal
            const tag = event.target;
            tag.style.opacity = '0';
            setTimeout(() => (tag.style.opacity = '1'), 2000);
        });
    }
  });
}




















  // Check if both 'savedSelectedVehicle' and 'savedvehicle' exist in localStorage
  if (
    localStorage.getItem("savedSelectedVehicle") &&
    localStorage.getItem("savedvehicle")
  ) {
    // Get the element with the ID 'activeYMMElement'
    const element = document.getElementById("activeYMMElement");

    if (element) {
      const storedYMM = localStorage.getItem("savedvehicle")
      // Change the inner HTML of the element
      element.innerHTML = storedYMM;
    }
  }

  // init homepage slider
  homePageSlider();

  // check init store in local storage and then populate state
  const persitedVehicle = localStorage.getItem("savedSelectedVehicle");
  let initSavedState = {};
  if (persitedVehicle && typeof persitedVehicle != "undefined") {
    initSavedState = JSON.parse(persitedVehicle);
  }

  Alpine.store("selectedVehicle", {
    make: initSavedState.make ? initSavedState.make : "",
    model: initSavedState.model ? initSavedState.model : "",
    year: initSavedState.year ? initSavedState.year : "",
    engine: {
      model: initSavedState.engine ? initSavedState.engine.model : "",
      modelRaw: initSavedState.engine ? initSavedState.engine.modelRaw : "",
      path: initSavedState.engine ? initSavedState.engine.path : "",
    },
    showLoadingUi: false,
    updateMake(data) {
      this.make = data;
    },
    updateModel(data) {
      this.model = data;
    },
    updateYear(data) {
      this.year = data;
    },
    updateEngine(data) {
      const parsedData = JSON.parse(data);
      this.engine.model = parsedData.model.split("_").join(" ");
      this.engine.modelRaw = parsedData.model;
      this.engine.path = parsedData.path;
    },
    clearAll() {
      (this.model = ""),
        (this.year = ""),
        (this.engine.model = ""),
        (this.engine.modelRaw = ""),
        (this.engine.path = "");
    },
  });

  Alpine.store("vehicleDataProvider", {
    makeAndModel: [],
    yearModel: {},
    engineData: [],
    setMakeAndModel(data) {
      this.makeAndModel = data;
    },
    setYearModel(data) {
      this.yearModel = data;
    },
    setEngineData(data) {
      this.engineData;
    },
  });

  Alpine.start();
  window.Alpine = Alpine;

  Alpine.store("vehicleDataProvider").setMakeAndModel(makeModelData());
  Alpine.store("vehicleDataProvider").setYearModel(yearModelData());
  Alpine.store("vehicleDataProvider").setEngineData(engineData());
});

document.addEventListener("handleStartSelect", (event) => {
  Alpine.store("selectedVehicle").clearAll();
});

document.addEventListener("triggerVehicleSelection", (event) => {
  Alpine.store("selectedVehicle").showLoadingUi = true;

  const path = Alpine.store("selectedVehicle").engine.path;

  // NOTE - all local state will be overwritten
  // set local storage to match previous site / flow
  localStorage.setItem("savedvehiclelink", path);
  localStorage.setItem(
    "savedvehicle",
    Alpine.store("selectedVehicle").engine.model
  );

  localStorage.setItem(
    "savedSelectedVehicle",
    JSON.stringify(Alpine.store("selectedVehicle"))
  );

  document.location.href = path;
});

const formatYearList = (data) => {
  if (Alpine.store("selectedVehicle").engine.model != "") return;

  if (data == "" || !data || typeof data != "string") return;
  const foundModelList = Alpine.store("vehicleDataProvider").yearModel.find(
    (o) => o.brand == data
  )?.models;
  if (!foundModelList || typeof foundModelList == "undefined") return; // null check
  //handle BMW with 3 series and x3 series
  if (data == "BMW") {
    let foundSpecificModel = Object.keys(foundModelList)?.find(
      (o) =>
        Alpine.store("selectedVehicle").model.replace(/ /g, "_") ==
        o.replace(/ /g, "_")
    );


    return foundModelList[foundSpecificModel];
  } else {
    let foundSpecificModel = Object.keys(foundModelList)?.find((o) =>
      Alpine.store("selectedVehicle").model.includes(
        (data = "BMW" ? o.replace(/ /g, "_") : o)
      )
    );


    return foundModelList[foundSpecificModel];
  }
};

const findEngineList = (data) => {


  if (data == "" || !data || typeof data != "string") return;

  let brand = Alpine.store("selectedVehicle").make.toString();
  let searchTerm = brand;
  if (brand == "Audi") {
    searchTerm =
      Alpine.store("selectedVehicle").model.split("_")[0] +
      "-" +
      Alpine.store("selectedVehicle").year.split("_")[0];
  } else if (brand == "VW") {
    searchTerm =
      Alpine.store("selectedVehicle").year.split("_")[0] +
      " " +
      Alpine.store("selectedVehicle").model.split("_")[0];
  }  else {

    searchTerm = Alpine.store("selectedVehicle")
      .year.split("(")[0]
      .replace(/_/, "");
  }


  if (!searchTerm) return;

  const dataSet = engineData();
  function findMultipleModelsBySeriesCodes(dataSet, codesString) {
    const seriesCodes = codesString.split("·_").map((code) => code.trim());
    const results = {};




    function searchModels(dataset) {
      for (const [make, seriesObj] of Object.entries(dataset)) {
        for (const seriesCode of seriesCodes) {
          if (seriesObj.hasOwnProperty(seriesCode)) {
            results[make] = results[make] || {};
            results[make][seriesCode] = seriesObj[seriesCode].models;
          }
        }

        for (const [series, content] of Object.entries(seriesObj)) {
          if (
            typeof content === "object" &&
            !Array.isArray(content) &&
            content !== null
          ) {
            searchModels({ [series]: content }); // Recursive call for deeper objects
          }
        }
      }
    }

    searchModels(dataSet);

    return results;
  }

  // Usage:
  const modelsData = findMultipleModelsBySeriesCodes(dataSet, searchTerm);

  if (!modelsData || typeof modelsData == "undefined") return;

  if (Object.keys(modelsData).length > 0) {

    const finalKey = Object.keys(modelsData[brand]);
    const finalResult = modelsData[brand][finalKey[0]];



    function convertObjectToArray(obj) {
      return Object.keys(obj).map((key) => ({
        model: key,
        path: obj[key],
      }));
    }

    const modelsArray = convertObjectToArray(finalResult);

    return modelsArray;
  } else {
    console.log("No models found for the given series codes.");
  }
};
window.customFunctions = {};
window.customFunctions.findYear = formatYearList;
window.customFunctions.findEngine = findEngineList;
